export type EditablePopoverPlacement = 'down' | 'up'

type RectLike = {
  top: number
  bottom: number
}

const gap = 8
const margin = 12

export function resolveEditablePopoverPlacement(
  anchor: RectLike,
  popover: { height: number },
  boundary: RectLike,
): EditablePopoverPlacement {
  const availableBelow = boundary.bottom - anchor.bottom - gap - margin

  return availableBelow >= popover.height ? 'down' : 'up'
}
